import type { AxiosResponse } from 'axios';
import { z } from 'zod';
import type { MutationResponse, PostRequestBody } from '@/types/api-types';
import type { paths } from '~/generated/auth/api-schema';
import { bareAuthApi } from './bare-auth-api';

const PATH = '/v1/auth/refresh' as const;
const TIMEOUT_MS = 10_000;

type RefreshTokenResponse = MutationResponse<paths, typeof PATH>;
type RefreshTokenPayload = PostRequestBody<paths, typeof PATH>;

const tokensSchema = z.object({
  token: z.string().min(1),
  refreshToken: z.string().min(1),
});

// The backend revokes the submitted pair once it issues a new one.
export const refreshTokens = async (tokens: RefreshTokenPayload) => {
  const { data: response } = await bareAuthApi.post<
    RefreshTokenResponse,
    AxiosResponse<RefreshTokenResponse>,
    RefreshTokenPayload
  >(PATH, tokens, { timeout: TIMEOUT_MS });

  return tokensSchema.parse(response.data);
};
